import { clsx } from 'clsx';
import { Box, Typography } from '@material-ui/core';

import CustomButton from '../common/buttons/custom-button';

import useStyles from './styles';

export function KanbanCardFooter(props) {
  const {
    classes = {},
    buttonText = '',
    footerText = '',
    secondaryButtonText = '',
    onClick = () => {},
    onClickSecondaryButton = () => {},
    productConfirmationCode = null,
    productConfirmationCodeLabel = '',
    isInCooking = false,
  } = props;

  const showRTHandoffBtn = !!productConfirmationCode && !isInCooking;
  const showMainBtn = !!buttonText && !showRTHandoffBtn;

  const _classes = useStyles();

  return (
    <>
      {(!!footerText ||
        !!buttonText ||
        !!secondaryButtonText ||
        !!productConfirmationCode) && (
        <div className={clsx(_classes.root, classes?.root)}>
          {!!footerText && (
            <div className={clsx(_classes.footerText, classes?.footerText)}>
              {footerText}
            </div>
          )}
          {showMainBtn && (
            <CustomButton
              classes={{
                root: _classes.buttonRoot,
                submitButton: _classes.buttonSubmitRoot,
              }}
              fullWidth={false}
              onClick={async e => {
                await onClick(e);
              }}
              variant='contained'
            >
              {buttonText}
            </CustomButton>
          )}
          {!!secondaryButtonText && (
            <CustomButton
              classes={{
                root: _classes.secondaryButtonRoot,
                submitButton: _classes.secondaryButtonSubmitRoot,
              }}
              fullWidth={false}
              onClick={async e => {
                await onClickSecondaryButton(e);
              }}
              variant='text'
            >
              {secondaryButtonText}
            </CustomButton>
          )}
          {showRTHandoffBtn && (
            <Box
              className={_classes.checkCodeContainer}
              display='flex'
              alignItems='center'
              justifyContent='center'
              padding='0.25rem 0.75rem'
            >
              <Typography className={_classes.checkCode}>
                {productConfirmationCodeLabel}: {productConfirmationCode}
              </Typography>
            </Box>
          )}
        </div>
      )}
    </>
  );
}
